import React from 'react'
import classNames from 'classnames'

export const OutreachStatTile = ({ icon, label, value, footer, variant, testId }) => (
  <div className={classNames('outreach-stat-tile', variant)} data-testid={testId}>
    <div className="outreach-stat-tile__label">
      {icon && <span className="outreach-stat-tile__icon">{icon}</span>}
      <span>{label}</span>
    </div>
    <div className="outreach-stat-tile__value">{value.toLocaleString()}</div>
    {footer && <div className="outreach-stat-tile__footer">{footer}</div>}
  </div>
)
